import React, { FC, useState } from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { RadioChangeEvent } from 'antd/lib/radio';

import { Form } from '~/components';
import { Beneficiary } from '~/types';
import { beneficiaries } from '~/routes';
import BusinessForm from './BusinessForm';
import IndividualForm from './IndividualForm';

interface BeneficiaryFormProps {
  name: typeof beneficiaries;
  initialValues?: Beneficiary;
  edit?: boolean;
}

const BeneficiaryForm: FC<BeneficiaryFormProps> = (props) => {
  const { initialValues = { type: 'BUSINESS' }, name, edit } = props;
  const [t] = useTranslation('payouts');

  const [beneficiaryType, setBenefitiaryType] = useState<'BUSINESS' | 'INDIVIDUAL'>(
    initialValues?.type
  );
  const changeBenefitiaryType = (e: RadioChangeEvent) => {
    const { value } = e.target;
    setBenefitiaryType(value);
  };

  const [form] = Form.useForm();

  return (
    <>
      <Form layout="vertical" form={form} name={name} initialValues={initialValues}>
        {!edit && (
          <Form.Item name="type" label={t('iAmAdding')}>
            <Radio.Group
              options={[
                { label: t('BUSINESS'), value: 'BUSINESS' },
                { label: t('INDIVIDUAL'), value: 'INDIVIDUAL' },
              ]}
              onChange={changeBenefitiaryType}
              optionType="button"
            />
          </Form.Item>
        )}
        {(() => {
          switch (beneficiaryType) {
            case 'BUSINESS':
              return (
                <BusinessForm
                  initialValues={initialValues as Beneficiary}
                  form={form}
                  edit={edit}
                />
              );
            case 'INDIVIDUAL':
              return (
                <IndividualForm
                  initialValues={initialValues as Beneficiary}
                  form={form}
                  edit={edit}
                />
              );
            default:
              return null;
          }
        })()}
      </Form>
    </>
  );
};

export default BeneficiaryForm;
